import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { useToast } from "../../contexts/ToastContext";

const ToastNotification = () => {
  const { toast, hideToast } = useToast();

  return (
    <ToastContainer
      position="top-end"
      className="p-3"
      style={{
        zIndex: 9999,
        position: "fixed",
        top: 20,
        right: 20,
      }}
    >
      <Toast
        show={toast.show}
        onClose={hideToast}
        bg={toast.type}
        delay={3000}
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">{toast.header}</strong>
        </Toast.Header>
        <Toast.Body
          className={
            toast.type === "danger" || toast.type === "success"
              ? "text-white"
              : "text-black"
          }
        >
          {toast.message}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default ToastNotification;
